import { Users } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import {
  FEATURE_EMPLOYEE_MANAGEMENT,
  FEATURE_INTEGRATIONS,
  PERMISSION_VIEW_EMPLOYEE_MANAGEMENT,
} from "../../utils/UserAccessControlUtils";
import EmployeeDirectoryPage from "./pages/EmployeeDirectoryPage";
import EmployeeAuditLogPage from "./pages/EmployeeAuditLogPage";

const EmployeeRouter: NavigationLinkProps[] = [
  {
    id: "2e56ba97-eb93-4f92-9146-e45a8e4a7106",
    title: "Employees",
    description: "",
    path: "/employees",
    auth: true,
    sidebar: true,
    icon: Users,
    component: EmployeeDirectoryPage,
    requiredFeature: FEATURE_EMPLOYEE_MANAGEMENT,
    requiredPermissions: [PERMISSION_VIEW_EMPLOYEE_MANAGEMENT],
  },
  {
    id: "7f12d5b8-9bd4-4c2c-9f6d-3e4b6a1f9d02",
    title: "Employee Audit Log",
    description: "",
    path: "/employees/:employeeId/audit-log",
    auth: true,
    sidebar: false,
    component: EmployeeAuditLogPage,
    requiredFeature: FEATURE_INTEGRATIONS,
    requiredPermissions: [PERMISSION_VIEW_EMPLOYEE_MANAGEMENT],
  },
];

export default EmployeeRouter;
